import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';


@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    CommonNgModule
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CardComponent {

  @Input() Theme: any;
  
  constructor() { }

  ngOnInit() {
  }

  setTheme(){
    // alert('setTheme');
  }
  
}
